var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"my-2 px-1 text-center"},[_c('small',[_vm._v("\n    "+_vm._s(_vm.$tc(
        `components.publication.${_vm.publication.publishable_type}.subject.${_vm.publication.publishable_subject}`,
        _vm.publication.attachables_count,
        {
          date: _vm.humanizeDate(_vm.publication.published_at),
          week_date: _vm.humanizeDate(_vm.publication.published_week_at, 'DATE_MED'),
          count: _vm.publication.attachables_count
        }
      ))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }